import { combineReducers } from 'redux'
import {
  USER_LIST_ERROR,
  USER_LIST_LOADING,
  USER_LIST_SUCCESS,

  USER_BANK_LIST_ERROR,
  USER_BANK_LIST_LOADING,
  USER_BANK_LIST_SUCCESS,

  USER_BANK_EDIT_ERROR,
  USER_BANK_EDIT_LOADING,
  USER_BANK_EDIT_SUCCESS,

  USER_ADD_ERROR,
  USER_ADD_LOADING,
  USER_ADD_SUCCESS,

  USER_CPW_ERROR,
  USER_CPW_LOADING,
  USER_CPW_SUCCESS,

  USER_VIEW_ERROR,
  USER_VIEW_LOADING,
  USER_VIEW_SUCCESS,

  USER_PAGE_LOADING,
  USER_PAGE_SUCCESS,
  USER_PAGE_ERROR,

  USER_EDIT_ERROR,
  USER_EDIT_LOADING,
  USER_EDIT_SUCCESS,

  USER_SET_STATUS_ERROR,
  USER_SET_STATUS_LOADING,
  USER_SET_STATUS_SUCCESS,

  USER_SHIPPER_VIEW_ERROR,
  USER_SHIPPER_VIEW_LOADING,
  USER_SHIPPER_VIEW_SUCCESS,

  USER_CONSIGNEE_LIST_ERROR,
  USER_CONSIGNEE_LIST_LOADING,
  USER_CONSIGNEE_LIST_SUCCESS,

  USER_SHIPPER_LIST_LOADING,
  USER_SHIPPER_LIST_SUCCESS,
  USER_SHIPPER_LIST_ERROR,

  STATUS_USER_ERROR,
  STATUS_USER_LOADING,
  STATUS_USER_SUCCESS,

  USER_REPORT_ERROR,
  USER_REPORT_LOADING,
  USER_REPORT_SUCCESS,
  USER_CP_ERROR,
  USER_CP_SUCCESS,
  USER_CP_LOADING,
  USER_DELETE_ERROR,
  USER_DELETE_LOADING,
  USER_DELETE_SUCCESS,
} from './constant'

const userListError = (state = false, action) => {
  switch (action.type) {
    case USER_LIST_ERROR:
      return action.userListError
    default:
      return state
  }
}

const userListLoading = (state = false, action) => {
  switch (action.type) {
    case USER_LIST_LOADING:
      return action.userListLoading
    default:
      return state
  }
}

const userListSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_LIST_SUCCESS:
      return action.userListSuccess
    default:
      return state
  }
}

const userBankListError = (state = false, action) => {
  switch (action.type) {
    case USER_BANK_LIST_ERROR:
      return action.userBankListError
    default:
      return state
  }
}

const userBankListLoading = (state = false, action) => {
  switch (action.type) {
    case USER_BANK_LIST_LOADING:
      return action.userBankListLoading
    default:
      return state
  }
}

const userBankListSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_BANK_LIST_SUCCESS:
      return action.userBankListSuccess
    default:
      return state
  }
}

const banks = (state = [], action) => {
  switch (action.type) {
    case USER_BANK_LIST_SUCCESS:
      return action.bank
    default:
      return state
  }
}

const userBankEditError = (state = false, action) => {
  switch (action.type) {
    case USER_BANK_EDIT_ERROR:
      return action.userBankEditError
    default:
      return state
  }
}

const userBankEditLoading = (state = false, action) => {
  switch (action.type) {
    case USER_BANK_EDIT_LOADING:
      return action.userBankEditLoading
    default:
      return state
  }
}

const userBankEditSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_BANK_EDIT_SUCCESS:
      return action.userBankEditSuccess
    default:
      return state
  }
}

const userPageError = (state = false, action) => {
  switch (action.type) {
    case USER_PAGE_ERROR:
      return action.userPageError
    default:
      return state
  }
}

const userPageLoading = (state = false, action) => {
  switch (action.type) {
    case USER_PAGE_LOADING:
      return action.userPageLoading
    default:
      return state
  }
}

const userPageSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_PAGE_SUCCESS:
      return action.userPageSuccess
    default:
      return state
  }
}

const users = (state = [], action) => {
  switch (action.type) {
    case USER_LIST_SUCCESS:
      return action.user
    case USER_PAGE_SUCCESS:
      return action.user
    default:
      return state
  }
}

const userAddError = (state = false, action) => {
  switch (action.type) {
    case USER_ADD_ERROR:
      return action.userAddError
    default:
      return state
  }
}

const userAddLoading = (state = false, action) => {
  switch (action.type) {
    case USER_ADD_LOADING:
      return action.userAddLoading
    default:
      return state
  }
}

const userAddSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_ADD_SUCCESS:
      return action.userAddSuccess
    default:
      return state
  }
}

const userCpwError = (state = false, action) => {
  switch (action.type) {
    case USER_CPW_ERROR:
      return action.userCpwError
    default:
      return state
  }
}

const userCpwLoading = (state = false, action) => {
  switch (action.type) {
    case USER_CPW_LOADING:
      return action.userCpwLoading
    default:
      return state
  }
}

const userCpwSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_CPW_SUCCESS:
      return action.userCpwSuccess
    default:
      return state
  }
}

const userCpError = (state = false, action) => {
  switch (action.type) {
    case USER_CP_ERROR:
      return action.userCpError
    default:
      return state
  }
}

const userCpLoading = (state = false, action) => {
  switch (action.type) {
    case USER_CP_LOADING:
      return action.userCpLoading
    default:
      return state
  }
}

const userCpSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_CP_SUCCESS:
      return action.userCpSuccess
    default:
      return state
  }
}

const userDeleteError = (state = false, action) => {
  switch (action.type) {
    case USER_DELETE_ERROR:
      return action.userDeleteError
    default:
      return state
  }
}

const userDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case USER_DELETE_LOADING:
      return action.userDeleteLoading
    default:
      return state
  }
}

const userDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_DELETE_SUCCESS:
      return action.userDeleteSuccess
    default:
      return state
  }
}

const userViewError = (state = false, action) => {
  switch (action.type) {
    case USER_VIEW_ERROR:
      return action.userViewError
    default:
      return state
  }
}

const userViewLoading = (state = false, action) => {
  switch (action.type) {
    case USER_VIEW_LOADING:
      return action.userViewLoading
    default:
      return state
  }
}

const userViewSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_VIEW_SUCCESS:
      return action.userViewSuccess
    default:
      return state
  }
}

const user = (state = [], action) => {
  switch (action.type) {
    case USER_VIEW_SUCCESS:
      return action.user
    default:
      return state
  }
}

const userEditError = (state = false, action) => {
  switch (action.type) {
    case USER_EDIT_ERROR:
      return action.userEditError
    default:
      return state
  }
}

const userEditLoading = (state = false, action) => {
  switch (action.type) {
    case USER_EDIT_LOADING:
      return action.userEditLoading
    default:
      return state
  }
}

const userEditSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_EDIT_SUCCESS:
      return action.userEditSuccess
    default:
      return state
  }
}

const setStatusError = (state = false, action) => {
  switch (action.type) {
    case USER_SET_STATUS_ERROR:
      return action.setStatusError
    default:
      return state
  }
}

const setStatusLoading = (state = false, action) => {
  switch (action.type) {
    case USER_SET_STATUS_LOADING:
      return action.setStatusLoading
    default:
      return state
  }
}

const setStatusSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_SET_STATUS_SUCCESS:
      return action.setStatusSuccess
    default:
      return state
  }
}

const userShipperViewError = (state = false, action) => {
  switch (action.type) {
    case USER_SHIPPER_VIEW_ERROR:
      return action.userShipperViewError
    default:
      return state
  }
}

const userShipperViewLoading = (state = false, action) => {
  switch (action.type) {
    case USER_SHIPPER_VIEW_LOADING:
      return action.userShipperViewLoading
    default:
      return state
  }
}

const userShipperViewSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_SHIPPER_VIEW_SUCCESS:
      return action.userShipperViewSuccess
    default:
      return state
  }
}

const shipper = (state = [], action) => {
  switch (action.type) {
    case USER_SHIPPER_VIEW_SUCCESS:
      return action.shipper
    default:
      return state
  }
}

const userConsigneeListError = (state = false, action) => {
  switch (action.type) {
    case USER_CONSIGNEE_LIST_ERROR:
      return action.userConsigneeListError
    default:
      return state
  }
}

const userConsigneeListLoading = (state = false, action) => {
  switch (action.type) {
    case USER_CONSIGNEE_LIST_LOADING:
      return action.userConsigneeListLoading
    default:
      return state
  }
}

const userConsigneeListSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_CONSIGNEE_LIST_SUCCESS:
      return action.userConsigneeListSuccess
    default:
      return state
  }
}

const consignees = (state = [], action) => {
  switch (action.type) {
    case USER_CONSIGNEE_LIST_SUCCESS:
      return action.consignees
    default:
      return state
  }
}

const userShipperListError = (state = false, action) => {
  switch (action.type) {
    case USER_SHIPPER_LIST_ERROR:
      return action.userShipperListError
    default:
      return state
  }
}

const userShipperListLoading = (state = false, action) => {
  switch (action.type) {
    case USER_SHIPPER_LIST_LOADING:
      return action.userShipperListLoading
    default:
      return state
  }
}

const userShipperListSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_SHIPPER_LIST_SUCCESS:
      return action.userShipperListSuccess
    default:
      return state
  }
}

const shippers = (state = [], action) => {
  switch (action.type) {
    case USER_SHIPPER_LIST_SUCCESS:
      return action.shippers
    default:
      return state
  }
}

const statusUserError = (state = false, action) => {
  switch (action.type) {
    case STATUS_USER_ERROR:
      return action.statusUserError
    default:
      return state
  }
}

const statusUserLoading = (state = false, action) => {
  switch (action.type) {
    case STATUS_USER_LOADING:
      return action.statusUserLoading
    default:
      return state
  }
}

const statusUserSuccess = (state = false, action) => {
  switch (action.type) {
    case STATUS_USER_SUCCESS:
      return action.statusUserSuccess
    default:
      return state
  }
}

const statusUser = (state = [], action) => {
  switch (action.type) {
    case STATUS_USER_SUCCESS:
      return action.statusUser
    default:
      return state
  }
}

const userReportError = (state = false, action) => {
  switch (action.type) {
    case USER_REPORT_ERROR:
      return action.userReportError
    default:
      return state
  }
}

const userReportLoading = (state = false, action) => {
  switch (action.type) {
    case USER_REPORT_LOADING:
      return action.userReportLoading
    default:
      return state
  }
}

const userReportSuccess = (state = false, action) => {
  switch (action.type) {
    case USER_REPORT_SUCCESS:
      return action.userReportSuccess
    default:
      return state
  }
}

const userReport = (state = [], action) => {
  switch (action.type) {
    case USER_REPORT_SUCCESS:
      return action.userReport
    default:
      return state
  }
}

const userReducer = combineReducers({
  userListError,
  userListLoading,
  userListSuccess,

  userBankListError,
  userBankListLoading,
  userBankListSuccess,
  banks,

  userBankEditError,
  userBankEditLoading,
  userBankEditSuccess,

  userPageError,
  userPageLoading,
  userPageSuccess,

  userAddError,
  userAddLoading,
  userAddSuccess,

  userCpwError,
  userCpwLoading,
  userCpwSuccess,

  userCpError,
  userCpLoading,
  userCpSuccess,

  userDeleteError,
  userDeleteLoading,
  userDeleteSuccess,

  userViewError,
  userViewLoading,
  userViewSuccess,

  userEditError,
  userEditLoading,
  userEditSuccess,

  setStatusError,
  setStatusLoading,
  setStatusSuccess,

  userShipperViewError,
  userShipperViewLoading,
  userShipperViewSuccess,

  userConsigneeListError,
  userConsigneeListLoading,
  userConsigneeListSuccess,

  userShipperListError,
  userShipperListLoading,
  userShipperListSuccess,

  users,
  user,
  shipper,
  consignees,
  shippers,

  statusUserError,
  statusUserLoading,
  statusUserSuccess,
  statusUser,

  userReportError,
  userReportLoading,
  userReportSuccess,
  userReport,
})

export default userReducer
